import { requiredValidatorFn } from './validator/required.validator';
import { emailValidatorFn } from './validator/email.validator';
import { phoneValidatorFn } from './validator/phone.validator';
import { ibanValidatorFn } from './validator/iban.validator';

export class FormValidators {
    static Required = requiredValidatorFn;
    static Email = emailValidatorFn;
    static Phone = phoneValidatorFn;
    static IBAN = ibanValidatorFn;
}
